import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Instagram, AlertTriangle } from 'lucide-react';
export function DiagnosisSection() {
  return <section className="py-24 bg-[#0a1120] relative" data-id="element-14">
      <div className="container mx-auto px-4 md:px-6" data-id="element-15">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-16">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center p-3 bg-red-500/10 rounded-full mb-6" data-id="element-17">
            <AlertTriangle className="text-red-400" size={28} data-id="element-18" />
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-19">
            ¿Su negocio aparece, pero{' '}
            <span className="text-red-400 border-b-2 border-red-400/30 pb-1" data-id="element-20">
              no vende?
            </span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-21">
          {/* Google Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-nova-navy-dark border border-nova-navy-light/30 rounded-2xl p-8 hover:border-nova-gold/30 transition-colors group relative overflow-hidden" data-id="element-22">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 group-hover:bg-blue-500/10 transition-colors" data-id="element-23" />

            <div className="w-14 h-14 bg-blue-500/10 rounded-xl flex items-center justify-center mb-6" data-id="element-24">
              <MapPin className="text-blue-400" size={28} data-id="element-25" />
            </div>

            <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-26">
              En Google Maps
            </h3>

            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-27">
              "Si tiene su perfil de Google Maps pero no tiene web, Google le da
              menos prioridad. Está perdiendo el tráfico de la gente que busca{' '}
              <strong className="text-white font-medium" data-id="element-28">
                servicios cerca de mí
              </strong>
              ."
            </p>
          </motion.div>

          {/* Instagram Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-nova-navy-dark border border-nova-navy-light/30 rounded-2xl p-8 hover:border-nova-gold/30 transition-colors group relative overflow-hidden" data-id="element-29">
            <div className="absolute top-0 right-0 w-32 h-32 bg-pink-500/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 group-hover:bg-pink-500/10 transition-colors" data-id="element-30" />

            <div className="w-14 h-14 bg-pink-500/10 rounded-xl flex items-center justify-center mb-6" data-id="element-31">
              <Instagram className="text-pink-400" size={28} data-id="element-32" />
            </div>

            <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-33">
              En Instagram
            </h3>

            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-34">
              "Tener seguidores es vanidad, tener citas es negocio. Su link de
              la biografía debe ser una{' '}
              <strong className="text-white font-medium" data-id="element-35">
                autopista hacia su caja registradora
              </strong>
              ."
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}